/**
 * Created by lvardarova on 29/04/16.
 */
import React from 'react';
import SvgIcon from '../../svgIcon/SvgIcon';

export function SocialInstagram(props) {
    return (
        <SvgIcon {...props}>
            <path fillRule="evenodd" clipRule="evenodd" d="M8.846,6.23h-0.87C8.039,6.477,8.077,6.734,8.077,7 c0,1.7-1.378,3.077-3.077,3.077S1.923,8.7,1.923,7c0-0.266,0.038-0.523,0.102-0.77H1.154v4.231c0,0.212,0.172,0.384,0.385,0.384 h6.922c0.213,0,0.385-0.172,0.385-0.384V6.23z M8.846,3.538c0-0.212-0.172-0.384-0.385-0.384H7.308 c-0.212,0-0.384,0.172-0.384,0.384v1.154c0,0.212,0.172,0.384,0.384,0.384h1.154c0.213,0,0.385-0.172,0.385-0.384V3.538z M5,5.077C3.938,5.077,3.077,5.938,3.077,7S3.938,8.923,5,8.923S6.923,8.062,6.923,7S6.062,5.077,5,5.077 M8.846,12H1.154 C0.517,12,0,11.483,0,10.846V3.154C0,2.516,0.517,2,1.154,2h7.692C9.484,2,10,2.516,10,3.154v7.692C10,11.483,9.484,12,8.846,12" />
        </SvgIcon>
    );
}

SocialInstagram.defaultProps = {
    viewBox: '0 0 16 16'
};

export default SocialInstagram;
